import React from 'react';
import { createRoot } from 'react-dom/client';

import 'reset-css/reset.css'
import './index.css';
import './common/gridism.css';
import './common/type.css';
import './common/branding.css';
import './common/helpers.css';

import App from './containers/App';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
